import { useEffect } from 'react'

const useClearCustomerToken = () => {
  useEffect(() => {
    localStorage.removeItem('jwt')
  }, [])
}

export default useClearCustomerToken
